import { SettingsPageContent } from 'components/SettingsPage/SettingsPageContent';
import { Title } from 'react-admin';

export const UserProfileEdit: React.FC = () => {
  return (
    <>
      <Title title="Profil" />
      <SettingsPageContent showAvatar={true} showInvitationLink={true} showRemoveAccount={false} showTitle={false} />
    </>
  );
};
